import { render, staticRenderFns } from "./nameDetail.vue?vue&type=template&id=431f1431&scoped=true"
import script from "./nameDetail.vue?vue&type=script&lang=js"
export * from "./nameDetail.vue?vue&type=script&lang=js"
import style0 from "./nameDetail.vue?vue&type=style&index=0&id=431f1431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f1431",
  null
  
)

export default component.exports